import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

function getHashId(hash: string) {
  try {
    return decodeURIComponent(hash.slice(1))
  } catch {
    return hash.slice(1)
  }
}

export default function ScrollToTop() {
  const { pathname, search, hash, key } = useLocation()

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      if (hash) {
        const target = document.getElementById(getHashId(hash))
        if (target) {
          target.scrollIntoView({ block: 'start' })
          return
        }
      }

      window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
    }, 0)

    return () => window.clearTimeout(timeoutId)
  }, [pathname, search, hash, key])

  return null
}
